module.exports = __webpack_public_path__ + "img/gold.be5030ca.webp";